import React from "react";
import styled from "styled-components";
import { color, font } from "../../theme/tokens";

const List = styled.div`
  display: flex;
  flex-direction: column;
`;

/* Alternating image/text columns, separated by a hairline rather than boxed. */
const Entry = styled.article`
  display: grid;
  grid-template-columns: minmax(0, 5fr) minmax(0, 7fr);
  gap: 56px;
  align-items: center;
  padding: 64px 0;
  border-top: 1px solid ${color.rule};

  &:first-child { border-top: none; padding-top: 0; }
  &:last-child { padding-bottom: 0; }

  &:nth-child(even) > figure { order: 2; }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 28px;
    padding: 44px 0;

    &:nth-child(even) > figure { order: 0; }
  }
`;

const Figure = styled.figure`
  margin: 0;

  img {
    width: 100%;
    aspect-ratio: 4 / 3;
    object-fit: cover;
    background: ${color.paperDeep};
  }
`;

const Company = styled.p`
  font-family: ${font.body};
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: ${color.clay};
  margin: 0 0 16px;
`;

const Name = styled.h3`
  font-family: ${font.display};
  color: ${color.inkStrong};
  font-size: 34px;
  font-weight: 400;
  letter-spacing: -0.01em;
  line-height: 1.15;
  margin: 0 0 20px;

  @media (max-width: 600px) { font-size: 26px; }
`;

const Description = styled.p`
  font-family: ${font.body};
  color: ${color.ink};
  font-size: 17px;
  line-height: 1.75;
  margin: 0;
  max-width: 60ch;

  @media (max-width: 600px) { font-size: 15px; }
`;

export default function FounderSpotlight({ entries = [] }) {
  return (
    <List>
      {entries.map((e, i) => (
        <Entry key={i}>
          <Figure>
            <img src={e.imageSrc} alt={`${e.name}, ${e.company}`} />
          </Figure>
          <div>
            <Company>{e.company}</Company>
            <Name>{e.name}</Name>
            <Description>{e.description}</Description>
          </div>
        </Entry>
      ))}
    </List>
  );
}
